<template>
    <form-partition :title="title" :rules="innerRules" :model="info">
        <loading-animation v-if="loading" />
        <div v-else>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="contractTplId" label="合同模板">
                        <Select
                            v-model="info.contractTplId"
                            :readonly="tplreadonly == true"
                            transfer
                            @on-option-click="onContractTplSelect"
                        >
                            <Option
                                v-for="item in contractTplList"
                                :value="item.id"
                                :key="item.id"
                                >{{
                                    item.tplTypeName + ' ' + item.tplName
                                }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <!-- <Col span="12">
                    <FormItem prop="entryContractType" label="合同类型">
                        <Select v-model="info.entryContractType" transfer>
                            <Option
                                v-for="item in entryContractTypes"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.text }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col> -->
                <Col span="12">
                    <FormItem prop="houseId" label="房源名称">
                        <form-lookup
                            v-model="info.houseId"
                            :options.sync="roomList"
                            :modalHeight="600"
                            :modalWidth="900"
                            :viewonly="
                                type === '2' || justRead || houseIdDisable
                            "
                            :disabled="houseIdDisable"
                            placeholder="请选择"
                            title="选择房间"
                            textSymbol="title"
                            valueSymbol="id"
                            @change="onSelectRoom"
                        >
                            <select-room
                                :houseStatus="houseStatus"
                                :allowCheckParent="false"
                            />
                        </form-lookup>
                    </FormItem>
                </Col>
            </Row>
            <!-- 不显示，仅为收集数据 -->
            <Row :gutter="20" v-show="false">
                <Col span="12">
                    <FormItem prop="houseName" label="房源名称">
                        <Input v-model="info.houseName" />
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="contractType" label="合同类型">
                        <Input v-model="info.contractType" />
                    </FormItem>
                </Col>
            </Row>

<!--            只在合同详情页显示-->
            <Row :gutter="20" v-show="this.type == '5'">
              <Col span="10">
                <FormItem label="合同编码" prop="contractCode">
                  <Input v-model="info.contractCode" />
                </FormItem>
              </Col>
            </Row>

            <!-- 合同类型说明 -->
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="合同类型说明">
                        <div
                            v-for="v in contractTplTypeList"
                            :key="v.id"
                            :class="{
                                'is-active': v.id === info.entryContractType,
                            }"
                        >
                            {{ v.remark.desc }}
                        </div>
                    </FormItem>
                </Col>
            </Row>
        </div>
    </form-partition>
</template>
<script>
import { Field } from 'ivux'
;``
import { contractTplList } from '@/api/configuration'
import Dict from '_u/dict'
import SelectRoom from '_vc/select-room'
import LoadingAnimation from '_v/components/loading-animation'
import { isEmpty } from "_u/helper";

export default {
    name: 'ContractInfo',
    mixins: [Field],
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        title: {
            type: String,
            default: '合同信息',
        },
        room: {
            type: Object,
            default: () => ({}),
        },
        type: {
            type: [Number, String],
            default: '',
        },
        houseStatus: {
            type: [Number, String],
            default: '1,2',
        },
        populateType: {
            type: String,
            default: 'through',
        },
        justRead: {
            type: Boolean,
            default: false,
        },
        houseIdDisable: {
            type: Boolean,
            default: false,
        },
    },
    components: { SelectRoom, LoadingAnimation },
    data() {
        return {
            loading: false,
            info: {
                houseId: '',
                contractTplId: '',
                houseName: '',
                contractType: '',
                entryContractType: '', // 合同类型
            },
            roomList: [],
            contractTplList: [], // 合同模板列表
            filter: {},
            dict: {
                entryContractType: Dict.NULL, // 录入合同类型
                contractTpl: Dict.NULL, // 合同模板类型
            },
            // 选择模板是否只读
            tplreadonly: false,
        }
    },
    watch: {
        value: {
            handler(val) {
                Object.assign(this.info, val)

                if (
                    this.justRead ||
                    this.type === '2' ||
                    this.type === '3' ||
                    this.type === '6'
                ) {
                    this.roomList.push({
                        id: this.info.houseId,
                        title: this.info.houseName,
                    })
                    this.filter = {
                        houseId: this.info.houseId,
                        title: this.info.houseName,
                    }
                }
            },
            immediate: true,
            deep: true,
        },
        'info.houseId'() {
            if (this.justRead || this.type !== '2' || this.type === '4') {
                const house = this.roomList[0]
                if (house) {
                    this.info.houseName = `${house.parkName}${house.floorName}${house.houseNum}`
                }
            }
            this.$emit('onHouseChange', this.info.houseId)
        },
        'info.contractTplId'(val) {
            const contract = this.contractTplList.find((v) => v.id === val)
            if (contract) {
                this.info.contractType = contract.tplType
            }
        },
    },
    computed: {
        innerRules() {
            let rule = {}
            if (!this.justRead) {
                rule = {
                    contractTplId: [
                        { required: true, message: '合同模板必填' },
                    ],
                    houseId: [{ required: true, message: '房源名称必填' }],
                    // contractCode: [{ required: true, message: '合同编码必填' }],
                }
            }
            return rule
        },
        entryContractTypes() {
            return this.dict.entryContractType.toList()
        },
        contractTplTypeList() {
            return this.dict.contractTpl.toList().map((v) => ({
                id: v.id,
                text: v.text,
                remark: JSON.safeParse(v.remark) || {},
            }))
        },
    },
    created() {
        if (this.room && this.room.id) {
            this.info.houseId = this.room.id
            this.room.title = this.getHeaderName(this.room)
            this.roomList.push(this.room)
        }
        this.fetch()
    },
    methods: {
        fetch() {
            this.loading = true
            Promise.all([
                contractTplList({ pageNo: 1, pageSize: 999 }),
                Dict.get(['entry_contract_type', 'contract_tpl']),
            ])
                .then((args) => {
                    var [res, dictGroup] = args

                    this.contractTplList = res.data.page.list

                    // 默认选中第一个模板(暂时取消此逻辑)
                    // if (
                    //   this.info.contractTplId == '' &&
                    //   this.contractTplList.length
                    // ) {
                    //   this.info.contractTplId = this.contractTplList[0].id
                    // }

                    //判断是否有打上默认标识的模板，如果有，则默认选择上
                    this.contractTplList.forEach((v) => {
                        if (v.isDefault == 1 && isEmpty(this.info.contractTplId)) {
                            this.info.contractTplId = v.id
                            this.onContractTplSelect({
                                label: v.text,
                                value: v.id,
                            })
                            // this.tplreadonly = true 不允许修改
                        }
                    })

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 选中合同模板
        onContractTplSelect({ label, value }) {
            var opt = this.contractTplList.find((v) => v.id === value)

            this.info.entryContractType = opt.tplType
            this.$emit('contract-tpl-select', {
                label,
                value,
                tplType: opt.tplType,
            })
        },
        // 选择房间
        onSelectRoom(value, options) {
            var item = options[0]

            Object.assign(this.filter, {
                parkId: item?.parkId || '',
                floorId: item?.floorId || '',
                floorNum: item?.floorNum || '',
                houseId: item?.houseId || '',
            })
        },
        // 获取标题
        getHeaderName(room) {
            let str = ''
            str += room.parkName ? room.parkName : ''
            str += room.floorName ? room.floorName : ''
            str += room.houseNum ? room.houseNum : ''
            return str
        },
    },
}
</script>
<style lang="less" scoped>
.is-active {
    color: #e6983c;
}
</style>
